/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable default-case */
/* eslint-disable no-console */
// src/msal.js
import * as msal from '@azure/msal-browser';
// src/msal.js

// ... existing imports and config

export default function configureMsal(adfsSettings, router, store) {
  const msalConfig = {
    auth: {
      clientId: adfsSettings.clientId,
      authority: adfsSettings.instance + adfsSettings.tenantId,
      redirectUri: adfsSettings.redirectUri || window.location.origin,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          switch (level) {
            case msal.LogLevel.Error:
              console.error(`MSAL Error: ${message}`);
              break;
            case msal.LogLevel.Warning:
              console.warn(`MSAL Warning: ${message}`);
              break;
            case msal.LogLevel.Info:
              console.info(`MSAL Info: ${message}`);
              break;
          }
        },
        logLevel: msal.LogLevel.Error,
      },
    },
  };

  const msalInstance = new msal.PublicClientApplication(msalConfig);

  // TWO SEPARATE REQUESTS
  const graphTokenRequest = {
    scopes: adfsSettings.graphScopes || ['User.Read'],
  };

  const apiTokenRequest = {
    scopes: adfsSettings.apiScopes || [],
  };

  const authenticationContext = {
    async initialize() {
      try {
        const response = await msalInstance.handleRedirectPromise();
        if (response) {
          // Use the account from redirect
          const account = response.account;
          /*
          store.dispatch('authorization/loadAuthorization', {
            token: response.accessToken,
            account,
          });
          */
          graphTokenRequest.account = account;
          apiTokenRequest.account = account;
        }

        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          graphTokenRequest.account = accounts[0];
          apiTokenRequest.account = accounts[0];
        }
        return this;
      } catch (error) {
        console.error('MSAL: Initialize error:', error);
        throw error;
      }
    },

    isAuthenticated() {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const account = accounts[0];
        graphTokenRequest.account = account;
        apiTokenRequest.account = account;
        return true;
      }
      return false;
    },

    async acquireApiToken() {
      if (!apiTokenRequest.account) {
        await this.initialize();
      }
      if (!apiTokenRequest.account) throw new Error('No account available');

      try {
        const response = await msalInstance.acquireTokenSilent(apiTokenRequest);
        store.dispatch('authorization/loadAuthorization', {
          token: response.accessToken,
          account: response.account,
        });
        return response.accessToken;
      } catch (error) {
        console.error('MSAL: acquireApiToken error:', error);
        if (
          error instanceof msal.InteractionRequiredAuthError
          || (error instanceof msal.BrowserAuthError && error.errorCode === 'monitor_window_timeout')
        ) {
          await msalInstance.acquireTokenRedirect(apiTokenRequest);
        } else {
          throw error;
        }
      }
    },

    async acquireGraphToken() {
      if (!graphTokenRequest.account) {
        await this.initialize();
      }
      try {
        const response = await msalInstance.acquireTokenSilent(graphTokenRequest);
        return response.accessToken;
      } catch (error) {
        if (error instanceof msal.InteractionRequiredAuthError) {
          await msalInstance.acquireTokenRedirect(graphTokenRequest);
        } else {
          throw error;
        }
      }
    },

    getUser() {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        return {
          name: accounts[0].name,
          username: accounts[0].username,
          profile: accounts[0],
        };
      }
      return null;
    },

    login() {
      // Login with BOTH scopes (so consent is granted)
      const loginRequest = {
        scopes: [...adfsSettings.graphScopes, ...adfsSettings.apiScopes],
      };
      msalInstance.loginRedirect(loginRequest);
    },

    logout() {
      msalInstance.logoutRedirect({
        postLogoutRedirectUri: msalConfig.auth.redirectUri,
      });
    },
  };

  // Router guard – acquire API token for protected routes
  router.beforeEach(async (to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      await authenticationContext.initialize();
      if (authenticationContext.isAuthenticated()) {
        try {
          await authenticationContext.acquireApiToken(); // ← API token
          next();
        } catch (error) {
          console.error('Router: API token failed:', error);
          authenticationContext.login();
        }
      } else {
        authenticationContext.login();
      }
    } else {
      next();
    }
  });

  return authenticationContext;
}
